export default __webpack_public_path__ + "src/assets/icn-cant-modify.5e294c403c5774a62afaa035f5083c08.svg";